import './bootstrap.css';
import './styles/global.css';
import '@glideapps/glide-data-grid/dist/index.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactGA from 'react-ga';

// @ts-ignore
import { hotjar } from 'react-hotjar';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import configureStore from './redux/configureStore';
import App from './App';

// Silence noisy console output in production by default (keep warn/error)
// Opt-out by setting REACT_APP_SILENCE_LOGS=false
(() => {
  const silenceEnv = String(process.env.REACT_APP_SILENCE_LOGS || '').toLowerCase();
  const shouldSilence =
    (process.env.NODE_ENV === 'production' && silenceEnv !== 'false') || silenceEnv === 'true';
  if (shouldSilence) {
    try {
      // no-op for debug/info/log/trace; preserve warn/error
      // eslint-disable-next-line no-console
      console.info('[logs] Silencing console logs (warn/error still shown)');
      const noop = () => { };
      // @ts-ignore
      console.log = noop;
      // @ts-ignore
      console.debug = noop;
      // @ts-ignore
      console.info = noop;
      // @ts-ignore
      console.trace = noop;
      // Optional: timing can be noisy too
      // @ts-ignore
      console.time = noop;
      // @ts-ignore
      console.timeEnd = noop;
    } catch { }
  }
})();

const HOTJAR_HJID = 1087421;
const HOTJAR_HJSV = 6;

hotjar.initialize(HOTJAR_HJID, HOTJAR_HJSV);

const store = configureStore();
ReactGA.initialize('UA-129074046-1');
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root') as HTMLElement
);

// UX: For numeric inputs defaulted to 0, select on focus so typing replaces 0
// and make replacing smoother on first key press.
function isNumericInput(el: any): el is HTMLInputElement {
  return (
    el &&
    el.tagName === 'INPUT' &&
    (el as HTMLInputElement).type === 'number'
  );
}

document.addEventListener('focusin', (e: Event) => {
  const target = e.target as HTMLInputElement | null;
  if (isNumericInput(target)) {
    // If the current value is exactly "0" or "0.0", select for easy replace
    const v = target.value;
    if (v === '0' || v === '0.0' || v === '0,0') {
      // Defer select to allow focus events to settle
      setTimeout(() => {
        try { target.select(); } catch { }
      }, 0);
    }
  }
});

document.addEventListener('keydown', (e: KeyboardEvent) => {
  const target = e.target as HTMLInputElement | null;
  if (!isNumericInput(target)) return;
  const v = target.value;
  // If value is a lone 0 and user presses a number or decimal separator, clear first
  const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
  const isDecimal = e.key === '.' || e.key === ',';
  const isNav = ['ArrowLeft', 'ArrowRight', 'Tab', 'Backspace', 'Delete', 'Home', 'End'].includes(e.key);
  if ((v === '0' || v === '0.0' || v === '0,0') && (isDigit || isDecimal) && !isNav) {
    // Replace whole content on first meaningful keystroke
    target.select();
  }
});
